import React from 'react';

import { Alert, Flex } from 'antd';

interface IOrganizationChildrenAlertProps {
  hasArchivedChildren: boolean;
  hasAnonymizedChildren: boolean;
}

export const OrganizationChildrenAlert = ({
  hasArchivedChildren,
  hasAnonymizedChildren,
}: IOrganizationChildrenAlertProps) => {
  if (!hasArchivedChildren && !hasAnonymizedChildren) return null;

  return (
    <Flex vertical gap="0.5rem">
      {hasArchivedChildren && (
        <Alert
          data-testid="organization-archived-alert"
          showIcon
          type="warning"
          message="This organisation has one or more archived child partners."
        />
      )}
      {hasAnonymizedChildren && (
        <Alert
          data-testid="organization-anonymized-alert"
          showIcon
          type="warning"
          message="This organisation has one or more anonymised child partners."
        />
      )}
    </Flex>
  );
};
